






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CheckoutEntry } from '@/interfaces/CheckoutEntry';
import { formatDateWithMonthName } from '@/helpers/dateFormatter';
import { ContractItem } from '@/interfaces/ContractItem';

@Component({
    name: 'CheckoutList',
})
export default class CheckoutList extends Vue {
    @Prop({required: true}) public checkoutList!: CheckoutEntry;

    protected sortMethod(a: CheckoutEntry, b: CheckoutEntry) {
        const firstDate = +new Date(a.createdAt);
        const secondDate = +new Date(b.createdAt);
        return firstDate - secondDate;
    }

    protected formattedDate(dateTimestamp: string) {
        return formatDateWithMonthName(dateTimestamp);
    }

    protected formattedIdList(contractItems: ContractItem[]) {
        return contractItems.map((contractItem: ContractItem) => contractItem.brand.importId).join(', ');
    }
}
